import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Domain } from '@shared/app/scripts/services/domain';
import { DeliveryPeriodModel } from '@classes/delivery-period-model';

/**
 * Service to expose /delivery-periods/* endpoints
 */
@Injectable()
export class DeliveryPeriodService {
  private getPrefix(tenantId: string) {
    if (tenantId) {
      return `${this.domain.getSpynl()}/tenants/${tenantId}`;
    }

    return this.domain.getSpynl();
  }

  constructor(
    @Inject(HttpClient) private httpClient: HttpClient,
    @Inject(Domain) private domain: Domain,
  ) {}

  /**
   * Get all delivery periods available for the user
   * @param tenantId: id of the tenant
   * @returns all delivery periods
   */
  getAll(tenantId?: string): Observable<DeliveryPeriodModel[]> {
    return this.httpClient
      .get<{
        data: DeliveryPeriodModel[];
      }>(`${this.getPrefix(tenantId)}/delivery-periods/get`, {})
      .pipe(
        map((response) => {
          return response.data.map((value) => new DeliveryPeriodModel(value));
        }),
      );
  }

  /**
   * Removes a delivery period from the collection.
   * @param id: document _id
   * @param tenantId: id of the tenant
   * @returns observable
   */
  remove(id: string, tenantId?: string) {
    return this.httpClient.post<{ data: string }>(
      `${this.getPrefix(tenantId)}/delivery-periods/remove`,
      { filter: { _id: id } },
    );
  }

  /**
   * Saves a delivery period object.
   * @param deliveryPeriod: the object to be saved
   * @param tenantId: id of the tenant
   * @returns promise which resolves to a document _id
   */
  save(deliveryPeriod: DeliveryPeriodModel, tenantId?: string) {
    return this.httpClient.post<{ data: DeliveryPeriodModel }>(
      `${this.getPrefix(tenantId)}/delivery-periods/save`,
      { data: deliveryPeriod },
    );
  }
}
